export default __webpack_public_path__ + "static/media/blueRightArrow.940d61c5.svg";